import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Input from "@mui/material/Input";
import Paper from "@mui/material/Paper";
import moment from "moment";
import CloudOffIcon from "@mui/icons-material/CloudOff";
import SearchIcon from "@mui/icons-material/Search";
import {
  briskBulkUploadPolicy,
  briskCertificateList,
  cancelBriskCertificate,
  formatCurrency,
  getBriskPolicyFileById,
  ReframeEndDateTimeFormat,
} from "../../Service/girnarApi";
import swal from "sweetalert";
import React from "react";
import {
  Autocomplete,
  Drawer,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import PropTypes from "prop-types";
import { visuallyHidden } from "@mui/utils";
import BriskCreateCertificate from "./BriskCreateCertificate";
import { ToastError, ToastSuccess } from "../../UiComponents/Toaster/Toast";
import Loader from "../../UiComponents/Loader/Loader";
import { GetUser } from "../../Service/UserService";
import FloatLabel from "../../UiComponents/FloatLabel/FloatLabel";
import { DownloadIcon, UploadIcon } from "../../Resources/Icons/icons";
import { CSVLink } from "react-csv";
import { DatePicker } from "antd";
import { FileUploader } from "react-drag-drop-files";
import dayjs from "dayjs";
import BriskBulkUpload from "./BriskBulkUpload";
const { RangePicker } = DatePicker;
const Last7Days = new Date();
Last7Days.setDate(Last7Days.getDate() - 7);
const TodayDate = new Date();

const BriskDownloadCertificate = () => {
  const [tableList, setTableList] = React.useState([]);
  const [summaryData, setSummaryData] = React.useState({});
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [openCreateCertificate, setOpenCreateCertificate] =
    React.useState(false);
  const [selectedData, setSelectedData] = React.useState({});
  const [selectedUser, setSelecteduser] = React.useState("");
  const [userDetails, setUserDetails] = React.useState([]);
  const [selectedStartDate, setSelectedStartDate] = React.useState(
    dayjs(Last7Days),
  );
  const [selectedEndDate, setSelectedEndDate] = React.useState(
    dayjs(TodayDate),
  );
  const [openLoader, setOpenLoader] = React.useState(false);
  const [bulkUploadFile, setBulkUploadFile] = React.useState(null);
  const [resetFileKey, setResetFileKey] = React.useState(1);
  const UserType = sessionStorage.getItem("userType");
  const [openBulkUpload, setOpenBulkUpload] = React.useState(false);
  const [drawerWidth, setDrawerWidth] = React.useState("25%");

  const headCells = [
    {
      id: "policyDate",
      placeMent: true,
      disablePadding: false,
      label: "Policy Date",
    },
    {
      id: "policyNumber",
      placeMent: true,
      disablePadding: false,
      label: "Policy Number",
    },
    {
      id: "chassisNo",
      placeMent: true,
      disablePadding: false,
      label: "Chassis No",
    },
    {
      id: "customerName",
      placeMent: true,
      disablePadding: false,
      label: "Customer Name",
    },
    {
      id: "registrationNumber",
      placeMent: true,
      disablePadding: false,
      label: "Reg Number",
    },
    // {
    //   id: "policyType",
    //   placeMent: true,
    //   disablePadding: false,
    //   label: "Policy Type",
    // },
    {
      id: "isBulkUpload",
      placeMent: true,
      disablePadding: false,
      label: "From Bulk Upload",
    },
    {
      id: "paymentMode",
      placeMent: true,
      disablePadding: false,
      label: "Payment Mode",
    },
    {
      id: "netPremium",
      placeMent: true,
      disablePadding: false,
      label: "Net Premium",
    },
    {
      id: "totalPremium",
      placeMent: true,
      disablePadding: false,
      label: "Total Premium",
    },
    {
      id: "email",
      placeMent: true,
      disablePadding: false,
      label: "User Email",
    },
    {
      id: "status",
      placeMent: true,
      disablePadding: false,
      label: "Status",
    },
    {
      id: "action",
      placeMent: true,
      disablePadding: false,
      label: "Action",
    },
  ];

  const header = [
    { label: "Issue Date", key: "issueDate" },
    { label: "User Name", key: "userName" },
    { label: "User Email", key: "userEmail" },
    { label: "Reference By", key: "refBy" },
    { label: "Policy Number", key: "policyNumber" },
    { label: "Customer Name", key: "payload.CustomerName" },
    { label: "Mobile Number", key: "payload.MobileNo" },
    { label: "Email ID", key: "payload.EmailID" },
    { label: "Reg Number", key: "payload.RegistrationNo" },
    { label: "Chassis No", key: "payload.ChassisNo" },
    { label: "Engine No", key: "payload.EngineNo" },
    { label: "Make", key: "payload.Make" },
    { label: "Model / Variant", key: "payload.Model" },
    { label: "Net Premium", key: "netPremium" },
    { label: "GST", key: "gst" },
    { label: "Total Premium", key: "totalPremium" },
    { label: "Payment Mode", key: "paymentMode" },
    { label: "Status", key: "status" },
  ];
  const csvFile = {
    filename: "Certificate Report",
    headers: header,
    data: tableList,
  };

  const [filter, setFilter] = React.useState({
    fn: (items) => {
      return items;
    },
  });

  React.useEffect(() => {
    getData(selectedStartDate, selectedEndDate);
    GetUserDetails();
  }, []);

  const getData = (startDate, endDate) => {
    //console.log("startDate, endDate ::", startDate, endDate);
    setOpenLoader(true);
    briskCertificateList("", startDate, endDate).then((res) => {
      setTableList(res?.data?.tableData);
      setSummaryData(res?.data?.summary);
      setOpenLoader(false);
    });
  };

  // const openPolicyFile = (row) => {
  //   window.open(row.downloadUrl, "_blank");
  // };

  const openPolicyFile = (row) => {
    // console.log("row ::", row);
    setOpenLoader(true);
    getBriskPolicyFileById(row?._id)
      .then((res) => {
        const pdfUrl = res?.data?.policyFile?.downloadURL;
        return pdfUrl;
      })
      .then((pdfUrl) => {
        setOpenLoader(false);
        // Changes by Arun
        const blobData = base64toBlob(pdfUrl, "application/pdf");
        const blobUrl = URL.createObjectURL(blobData);
        setOpenLoader(false);
        const pdfWindow = window.open("", "_blank");
        pdfWindow?.document?.write(
          // `<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`
          `<embed src="${blobUrl}" width="100%" height="100%" />`,
        );
        // const pdfWindow = window.open("", "_blank");
        // pdfWindow?.document?.write(`<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`);
      });
  };

  // Changes by Arun
  const base64toBlob = (base64Data, contentType) => {
    contentType = contentType || "";
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  };

  EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
  };

  const uploadExcel = async () => {
    // console.log("csvLinkRef.current.link : ", ccEntryFile);
    if (!bulkUploadFile) {
      ToastError("Please upload Bulk policy excel data");
      return true;
    }
    let formData = new FormData();
    formData.append(bulkUploadFile, bulkUploadFile);
    setOpenLoader(true);
    await briskBulkUploadPolicy(formData)
      .then((res) => {
        if (res?.message) {
          ToastSuccess(res.message);
          setBulkUploadFile(null);
          getData(selectedStartDate, dayjs(new Date()).endOf("day"));
        }
        // UniversalSearch(true);
      })
      .finally(() => {
        setOpenLoader(false);
      });
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const stableSort = (array, comparator) => {
    const stabilizedThis = array?.map((el, index) => [el, index]);
    stabilizedThis?.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis?.map((el) => el[0]);
  };

  const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  };

  const onSearch = (e) => {
    let target = e.target;
    setFilter({
      fn: (items) => {
        if (target.value == "") return items;
        else
          return items.filter((el) =>
            `${el?.customerName},${el?.issueDate},${el?.chassisNo},${el?.paymentMode},${el?.policyNumber},${el?.userEmail},${el?.registrationNumber},${el?.totalPremium},${el?.netPremium},${el?.status}`
              .toLowerCase()
              .includes(target.value.toLowerCase()),
          );
      },
    });
    setPage(0);
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/files/Brisk_BulkUpload_Template.xlsx"; // Path in the public folder
    link.download = "Brisk_BulkUpload_Template.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const GetUserDetails = () => {
    const bodyData = {
      requesttype: "TABLE",
      isAscending: true,
    };
    GetUser(bodyData)
      .then((res) => {
        const FilteredData = res.data
          .map((e) => {
            if (e.userType.includes("user")) {
              return {
                ...e,
                label: e.name + " - " + e.mobileNumber + " - " + e.email,
                value: e?._id,
              };
            } else {
              return null;
            }
          })
          .filter(Boolean);
        setUserDetails(FilteredData);
      })
      .catch((err) => ToastError("Network Error"));
  };

  const openCertificate = (row) => {
    if (row.status == "PENDING") {
      setSelectedData(row);
      setOpenCreateCertificate(true);
    }

    if (row.status == "CREATED") {
      if (UserType != "CLIENT") {
        ToastError("You can't cancel this policy, please contact admin!");
        return true;
      }
      swal("Are you want to cancel certificate!", {
        dangerMode: true,
        buttons: true,
      }).then(async (value) => {
        console.log("value ", value);
        if (value) {
          setOpenLoader(true);
          await cancelBriskCertificate({ policyNumber: row.policyNumber })
            .then((res) => {
              ToastSuccess(res?.data?.message);
              getData(selectedStartDate, dayjs(new Date()));
            })
            .finally(() => setOpenLoader(false));
        }
      });
    }
  };

  const getComparator = (order, orderBy) => {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  };

  const BulkUploadFunction = () => {
    setOpenBulkUpload(true);
  };

  const SearchFunction = async () => {
    // GetData();
    if (!selectedStartDate || !selectedEndDate) {
      ToastError("Please select start date and end date");
      return;
    }
    setOpenLoader(true);
    let endDate = null;
    if (selectedEndDate) {
      endDate = await ReframeEndDateTimeFormat(selectedEndDate);
    }

    briskCertificateList(selectedUser, selectedStartDate, endDate).then(
      (res) => {
        // console.log("selectedUser :::", selectedUser);
        setTableList(res?.data?.tableData);
        setSummaryData(res?.data?.summary);
        setOpenLoader(false);
      },
    );
  };

  const visibleRows = React.useMemo(
    () =>
      stableSort(filter.fn(tableList), getComparator(order, orderBy))?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      ),
    [order, orderBy, page, rowsPerPage, filter, tableList],
  );

  function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort, rejectedPolicy } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    const celltoMap = headCells;

    return (
      <TableHead>
        <TableRow>
          {celltoMap?.map((headCell) => (
            <TableCell
              className="TableHeader"
              key={headCell.id}
              align={headCell.placeMent ? "left" : "center"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
              sx={{ fontSize: "16px", fontWeight: 600 }}
              style={{ minWidth: headCells.minWidth }}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  return (
    <>
      <Grid
        container
        spacing={2}
        sx={{ padding: "10px 10px 0 10px" }}
        className="Master_Header_Container"
      >
        <Grid
          item
          sm={3}
          xs={12}
          sx={{ display: UserType == "CLIENT" ? "block" : "none" }}
        >
          <FloatLabel label="Select User" value={selectedUser}>
            <Autocomplete
              className="AutoComplete_InputBox"
              disablePortal
              id="combo-box-demo"
              options={userDetails}
              onChange={(e, v) => setSelecteduser(v?._id)}
              renderInput={(params) => <TextField {...params} />}
              renderOption={(props, option) => (
                <li {...props} key={option._id}>
                  {option.name +
                    " - " +
                    option.mobileNumber +
                    " - " +
                    option.email}
                </li>
              )}
            />
          </FloatLabel>
        </Grid>
        <Grid item sm={2} xs={12} className="datePicker">
          <FloatLabel label="Start date & End Date" value="react">
            <RangePicker
              placement="bottomLeft"
              className="textField w-100"
              style={{ borderRadius: "0px" }}
              defaultValue={[selectedStartDate, selectedEndDate]}
              onChange={(e) => {
                setSelectedStartDate(e ? e[0].$d : null);
                setSelectedEndDate(e ? e[1].$d : null);
              }}
              format="DD/MM/YYYY"
            />
          </FloatLabel>
        </Grid>
        <Grid
          item
          sm={1}
          xs={12}
          sx={{
            marginBottom: "8px",
          }}
          gap={2}
        >
          <Button
            className="Master_Header_create_Button"
            sx={{ width: { xs: "100%", sm: "100%" } }}
            onClick={SearchFunction}
          >
            Search
          </Button>
        </Grid>
        <Grid item xs={12} sm={3}>
          {/* <Box
            sx={{
              height: "35px",
              "& > label": { height: "100%" },
              minWidth: "100px",
            }}
          >
            <FileUploader
              handleChange={(e) => {
                // console.log("e", e);
                setBulkUploadFile(e);
              }}
              fileOrFiles={bulkUploadFile}
              name="BulkUploadFile"
              label="Upload Excel"
              dropMessageStyle={{
                color: "red",
                border: "none",
                borderRadius: "0px",
              }}
              types={["XLSX", "XLS"]}
              key={resetFileKey}
            />
          </Box> */}
        </Grid>
        <Grid item xs={12} sm={1.5}>
          {/* <Button
            className="Master_Header_create_Button w-100"
            endIcon={<UploadIcon />}
            onClick={() => {
              uploadExcel();
            }}
            sx={{ width: { xs: "100%", sm: "fit-content" } }}
          >
            Import Data
          </Button> */}
        </Grid>
        <Grid item xs={12} sm={1.5} className="d-flex justify-content-end">
          {/* <Button
            className="Master_Header_create_Button w-100"
            onClick={() => {
              handleDownload();
            }}
            endIcon={<DownloadIcon />}
            sx={{ width: { xs: "100%", sm: "fit-content" } }}
          >
            Sample Data
          </Button> */}
          <Button
            className="Master_Header_create_Button"
            endIcon={<UploadIcon />}
            sx={{ width: { xs: "100%", sm: "100%" } }}
            onClick={BulkUploadFunction}
          >
            Bulk Upload
          </Button>
        </Grid>
      </Grid>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={1} px={1} className="Master_Header_Container">
          <Grid item xs={12} sm={2}>
            <Typography
              className="Master_Header_Heading"
              sx={{ paddingLeft: "4px" }}
            >
              Download Certificate
            </Typography>
          </Grid>
          <Grid item xs={12} sm={7} />
          <Grid
            item
            sm={8.5}
            xs={12}
            className="Count_Page"
            sx={{ flexDirection: { xs: "column", sm: "row" } }}
            mt={2}
            gap={1}
          >
            <Grid className="Count_1" sx={{ width: "24%" }}>
              <Typography className="Total">
                {formatCurrency(summaryData?.count || 0)}
              </Typography>
              <Typography className="Title">Policy Count </Typography>
            </Grid>
            <Grid className="Count_2" sx={{ width: "24%" }}>
              <Typography className="Total">
                {formatCurrency(summaryData?.totalPremium || 0)}
              </Typography>
              <Typography className="Title">Total Premium</Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={2} mt={4}>
            <Input
              focused="false"
              className="w-100 Master_Header_Input"
              id="standard-adornment-password"
              onChange={onSearch}
              disableUnderline={true}
              placeholder="Search"
              startAdornment={
                <InputAdornment position="start">
                  <IconButton aria-label="toggle password visibility">
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={1.5}
            mt={4}
            className="d-flex justify-content-end"
          >
            <Button
              className="Master_Header_create_Button w-100"
              endIcon={<DownloadIcon />}
              sx={{ width: { xs: "100%", sm: "fit-content" } }}
            >
              <CSVLink className="Download_Excel_Button" {...csvFile}>
                Download Excel
              </CSVLink>
            </Button>
          </Grid>
        </Grid>
      </Box>

      <div className="d-flex PageContainer">
        <Paper className="container-fluid TableBox">
          <TableContainer className="TableContainer">
            <Table
              aria-labelledby="tableTitle"
              size="medium"
              stickyHeader
              aria-label="sticky table"
              sx={{ minWidth: 750 }}
            >
              <EnhancedTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {visibleRows?.map((row, index) => {
                  return (
                    <TableRow
                      hover
                      tabIndex={-1}
                      key={index}
                      sx={{ cursor: "pointer" }}
                    >
                      <TableCell component="th" scope="row" padding="normal">
                        {moment(row.issueDate).format("D-M-Y")}
                      </TableCell>
                      <TableCell align="left" sx={{ color: "blue" }}>
                        <label
                          onClick={() => openPolicyFile(row)}
                          style={{
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                        >
                          {row?.policyNumber}
                        </label>
                      </TableCell>
                      <TableCell align="left">
                        {row?.payload?.ChassisNo}
                      </TableCell>
                      <TableCell align="left">
                        {row?.payload?.CustomerName}
                      </TableCell>
                      <TableCell align="left">
                        {row?.payload?.RegistrationNo}
                      </TableCell>
                      {/* <TableCell align="left">{row?.policyType}</TableCell> */}
                      <TableCell align="left">
                        {row?.isBulkUpload ? "Yes" : "No"}
                      </TableCell>
                      <TableCell align="left">{row?.paymentMode}</TableCell>
                      {/* <TableCell align="left">{row?.odPremium}</TableCell> */}
                      <TableCell align="left">{row?.netPremium}</TableCell>
                      <TableCell align="left">{row?.totalPremium}</TableCell>
                      <TableCell align="left">{row?.userEmail}</TableCell>
                      <TableCell
                        align="left"
                        style={{
                          color:
                            row.status == "CREATED"
                              ? "GREEN"
                              : row.status == "CANCELED"
                                ? "RED"
                                : "BLUE",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {row?.status}
                      </TableCell>
                      <TableCell align="left">
                        <Button
                          className="TabelButton w-100"
                          sx={{
                            fontSize: "10px",
                            display:
                              row.status != "CANCELED" ? "block" : "none",
                            backgroundColor:
                              row.status == "CREATED"
                                ? "red !important"
                                : "BLUE",
                          }}
                          onClick={() => openCertificate(row)}
                        >
                          {row.status == "CREATED"
                            ? "CANCEL POLICY"
                            : row.status}
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })}
                {visibleRows?.length < 1 ? (
                  <TableRow>
                    <TableCell
                      colSpan={12}
                      sx={{ textAlign: "center", border: "none" }}
                    >
                      <CloudOffIcon
                        sx={{ fontSize: "100px", color: "#c5c3c3" }}
                      />
                      <br />
                      <Typography sx={{ color: "#c5c3c3" }}>
                        Oops! No Data Found
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : null}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filter.fn(tableList)?.length || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
        <Loader open={openLoader} />
      </div>
      <Drawer
        open={openBulkUpload}
        sx={{
          zIndex: 101,
        }}
        anchor="right"
        PaperProps={{
          sx: { width: { xs: "100%", sm: drawerWidth } },
        }}
      >
        {openBulkUpload ? (
          <BriskBulkUpload
            setOpenBulkUpload={setOpenBulkUpload}
            setDrawerWidth={setDrawerWidth}
            getData={getData}
            selectedStartDate={selectedStartDate}
          />
        ) : null}
      </Drawer>
      <Drawer
        open={openCreateCertificate}
        sx={{ zIndex: 100 }}
        anchor="right"
        PaperProps={{ sx: { width: { xs: "100%", sm: "100%" } } }}
      >
        {openCreateCertificate ? (
          <BriskCreateCertificate
            selectedData={selectedData}
            isEdit={openCreateCertificate}
          />
        ) : null}
      </Drawer>
    </>
  );
};

export default BriskDownloadCertificate;
